import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f268edac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "searchFrom" }
const _hoisted_2 = {
  class: "charts-section",
  style: {"margin-top":"20px","margin-bottom":"20px"}
}
const _hoisted_3 = { class: "chart-row" }
const _hoisted_4 = { class: "chart-item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chart-title" }, "被封账户", -1))
const _hoisted_6 = {
  ref: "stopChartRef",
  class: "chart-container"
}
const _hoisted_7 = { class: "chart-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chart-title" }, "使用中", -1))
const _hoisted_9 = {
  ref: "useChartRef",
  class: "chart-container"
}
const _hoisted_10 = { class: "chart-row" }
const _hoisted_11 = { class: "chart-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chart-title" }, "未分配-有消耗", -1))
const _hoisted_13 = {
  ref: "notUseExpendChartRef",
  class: "chart-container"
}
const _hoisted_14 = { class: "chart-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chart-title" }, "未分配-未消耗", -1))
const _hoisted_16 = {
  ref: "notUseNotExpendChartRef",
  class: "chart-container"
}
const _hoisted_17 = { style: {"margin-top":"20px"} }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { key: 3 }
const _hoisted_22 = {
  key: 0,
  style: {"margin-top":"4px","font-size":"12px","color":"#666"}
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { key: 3 }
const _hoisted_27 = {
  key: 0,
  style: {"color":"gray","font-size":"13px"}
}
const _hoisted_28 = { key: 2 }
const _hoisted_29 = { class: "intro-cell" }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = {
  key: 0,
  style: {"display":"flex","flex-wrap":"wrap","gap":"4px"}
}
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { style: {"display":"flex","align-items":"center","gap":"8px"} }
const _hoisted_34 = {
  key: 0,
  style: {"display":"inline-flex","align-items":"center"}
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"13px","height":"13px","border-radius":"50%","background-color":"#52c41a","display":"inline-block"} }, null, -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  key: 1,
  style: {"display":"inline-flex","align-items":"center"}
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"13px","height":"13px","border-radius":"50%","background-color":"#d9d9d9","display":"inline-block"} }, null, -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_DownOutlined = _resolveComponent("DownOutlined")!
  const _component_UpOutlined = _resolveComponent("UpOutlined")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_XAtable = _resolveComponent("XAtable")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_x_dialog = _resolveComponent("x-dialog")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_form, {
        name: "customized_form_controls",
        layout: "inline",
        model: $setup.searchFormState,
        ref: "searchFormRef"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            name: "adsId",
            label: "广告账户ID"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: $setup.searchFormState.adsId,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchFormState.adsId) = $event)),
                placeholder: "请输入广告账户ID"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            name: "createBy",
            label: "创建者(户)"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: $setup.searchFormState.createBy,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (($setup.searchFormState.createBy) = $event)),
                placeholder: "请选择或搜索创建者(户)",
                "show-search": "",
                "filter-option": false,
                onSearch: $setup.handleCreatorFilterSearch,
                onPopupScroll: $setup.handleCreatorFilterScroll,
                onFocus: $setup.handleCreatorFilterFocus,
                onClear: $setup.handleCreatorFilterClear,
                loading: $setup.creatorFilterLoading,
                "option-label-prop": "label",
                "allow-clear": "",
                style: {"min-width":"260px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.creatorFilterList, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: item.id,
                      value: item.id,
                      label: item.name
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "onSearch", "onPopupScroll", "onFocus", "onClear", "loading"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            name: "userId",
            label: "用户ID"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: $setup.searchFormState.userId,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (($setup.searchFormState.userId) = $event)),
                placeholder: "请输入用户ID"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            name: "status",
            label: "状态"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: $setup.searchFormState.status,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (($setup.searchFormState.status) = $event)),
                style: {"min-width":"120px"},
                placeholder: "请选择状态"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: "" }, {
                    default: _withCtx(() => [
                      _createTextVNode("全部")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "0" }, {
                    default: _withCtx(() => [
                      _createTextVNode("待出售")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "1" }, {
                    default: _withCtx(() => [
                      _createTextVNode("已出售")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "2" }, {
                    default: _withCtx(() => [
                      _createTextVNode("被封禁")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            name: "isShow",
            label: "上架"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: $setup.searchFormState.isShow,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (($setup.searchFormState.isShow) = $event)),
                style: {"min-width":"120px"},
                placeholder: "请选择上架",
                "allow-clear": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: "" }, {
                    default: _withCtx(() => [
                      _createTextVNode("全部")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode("否")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode("是")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            name: "online",
            label: "FB连接"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: $setup.searchFormState.online,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (($setup.searchFormState.online) = $event)),
                style: {"min-width":"120px"},
                placeholder: "请选择FB连接状态",
                "allow-clear": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: "" }, {
                    default: _withCtx(() => [
                      _createTextVNode("全部")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode("离线")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode("在线")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                style: {"margin-right":"10px"},
                onClick: $setup.resetForm
              }, {
                default: _withCtx(() => [
                  _createTextVNode("重置")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: $setup.search,
                style: {"margin-right":"10px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("搜索")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: $setup.addClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode("添加")
                ]),
                _: 1
              }, 8, ["onClick"])), [
                [_directive_permission, 'sysData.list.add']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_a_upload, {
                "before-upload": $setup.handleBatchAddUpload,
                "show-upload-list": false,
                accept: ".xls,.xlsx",
                style: {"margin-left":"10px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    loading: $setup.batchAddLoading
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 批量添加 ")
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              }, 8, ["before-upload"])), [
                [_directive_permission, 'sysData.list.add']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_a_upload, {
                "before-upload": $setup.handleBatchDisableXlsUpload,
                "show-upload-list": false,
                accept: ".xls,.xlsx",
                style: {"margin-left":"10px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    loading: $setup.batchDisableXlsLoading
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 批量停用xls ")
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              }, 8, ["before-upload"])), [
                [_directive_permission, 'sysData.list.update']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: $setup.exportStopAccountClick,
                style: {"margin-left":"10px"},
                loading: $setup.exportStopAccountLoading
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 导出禁用账户xls ")
                ]),
                _: 1
              }, 8, ["onClick", "loading"])), [
                [_directive_permission, 'sysData.list.update']
              ]),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: $setup.toggleCharts,
                style: {"margin-left":"10px"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString($setup.chartsVisible ? "收起图表" : "展开图表"), 1),
                  (!$setup.chartsVisible)
                    ? (_openBlock(), _createBlock(_component_DownOutlined, {
                        key: 0,
                        style: {"margin-left":"8px"}
                      }))
                    : (_openBlock(), _createBlock(_component_UpOutlined, {
                        key: 1,
                        style: {"margin-left":"8px"}
                      }))
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, null, 512)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, null, 512)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, null, 512)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, null, 512)
            ])
          ])
        ], 512), [
          [_vShow, $setup.chartsVisible]
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_XAtable, {
        columns: $setup.columns,
        dataSource: $setup.tableData,
        loading: $setup.loading,
        scroll: { x: 1660 }
      }, {
        status: _withCtx(({ scope }) => [
          _createElementVNode("div", null, [
            ((scope.record as any).status === 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                  _createVNode(_component_a_tag, { color: "orange" }, {
                    default: _withCtx(() => [
                      _createTextVNode("待出售")
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            ((scope.record as any).status === 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                  _createVNode(_component_a_tag, { color: "green" }, {
                    default: _withCtx(() => [
                      _createTextVNode("已出售")
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            ((scope.record as any).status === 2)
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                  _createVNode(_component_a_tag, { color: "red" }, {
                    default: _withCtx(() => [
                      _createTextVNode("被封禁")
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            ((scope.record as any).status === null)
              ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                  _createVNode(_component_a_tag, { color: "gray" }, {
                    default: _withCtx(() => [
                      _createTextVNode("未设置")
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          ((scope.record as any).status === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                ((scope.record as any).stopType === 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, "未知"))
                  : _createCommentVNode("", true),
                ((scope.record as any).stopType === 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, "客户问题"))
                  : _createCommentVNode("", true),
                ((scope.record as any).stopType === 2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, "技术封禁"))
                  : _createCommentVNode("", true),
                ((scope.record as any).stopType === undefined || (scope.record as any).stopType === null)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, "-"))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        createBy: _withCtx(({ scope }) => [
          _createElementVNode("div", null, _toDisplayString(scope.record.createByName), 1)
        ]),
        userName: _withCtx(({ scope }) => [
          _createElementVNode("div", null, _toDisplayString(scope.record.userName), 1),
          (scope.record.userId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, " ID:" + _toDisplayString(scope.record.userId), 1))
            : _createCommentVNode("", true)
        ]),
        isShow: _withCtx(({ scope }) => [
          ((scope.record as any).isShow === 1)
            ? (_openBlock(), _createBlock(_component_a_tag, {
                key: 0,
                color: "green"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("是")
                ]),
                _: 1
              }))
            : ((scope.record as any).isShow === 0)
              ? (_openBlock(), _createBlock(_component_a_tag, {
                  key: 1,
                  color: "default"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("否")
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("span", _hoisted_28, "-"))
        ]),
        price: _withCtx(({ scope }) => [
          _createElementVNode("span", null, _toDisplayString($setup.formatPrice((scope.record as any).price)), 1)
        ]),
        intro: _withCtx(({ scope }) => [
          ((scope.record as any).intro)
            ? (_openBlock(), _createBlock(_component_a_tooltip, {
                key: 0,
                title: (scope.record as any).intro
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_29, _toDisplayString((scope.record as any).intro), 1)
                ]),
                _: 2
              }, 1032, ["title"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_30, "-"))
        ]),
        tag: _withCtx(({ scope }) => [
          ($setup.parseTagToArray((scope.record as any).tag).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.parseTagToArray((scope.record as any).tag), (item, index) => {
                  return (_openBlock(), _createBlock(_component_a_tag, {
                    key: index,
                    color: "blue"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_32, "-"))
        ]),
        online: _withCtx(({ scope }) => [
          _createElementVNode("div", _hoisted_33, [
            (scope.record.online === 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_34, _hoisted_36))
              : (scope.record.online === 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_37, _hoisted_39))
                : (_openBlock(), _createElementBlock("span", _hoisted_40, "-")),
            (scope.record.bmBase && scope.record.adsId)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 3,
                  type: "link",
                  size: "small",
                  onClick: ($event: any) => ($setup.openFbAdAccountManage(scope.record))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("管理")
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (scope.record.bmBase && scope.record.adsId)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 4,
                  type: "link",
                  size: "small",
                  onClick: ($event: any) => ($setup.openFbAdAccountFinance(scope.record))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("财务")
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        control: _withCtx(({ scope }) => [
          _withDirectives((_openBlock(), _createBlock(_component_a_button, {
            type: "primary",
            size: "small",
            onClick: ($event: any) => ($setup.editClick(scope.record as any)),
            style: {"margin-right":"8px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode("编辑")
            ]),
            _: 2
          }, 1032, ["onClick"])), [
            [_directive_permission, 'sysData.list.update']
          ]),
          _createVNode(_component_a_popconfirm, {
            title: "确定删除该数据?",
            "ok-text": "确定",
            "cancel-text": "取消",
            onConfirm: ($event: any) => ($setup.deleteClick(scope.record as any))
          }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                danger: "",
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("删除")
                ]),
                _: 1
              })), [
                [_directive_permission, 'sysData.list.update']
              ])
            ]),
            _: 2
          }, 1032, ["onConfirm"])
        ]),
        _: 1
      }, 8, ["columns", "dataSource", "loading"]),
      _createVNode(_component_a_pagination, {
        current: $setup.pageNo,
        "onUpdate:current": _cache[6] || (_cache[6] = ($event: any) => (($setup.pageNo) = $event)),
        onChange: $setup.pageNoChange,
        total: $setup.total,
        hideOnSinglePage: "",
        onShowSizeChange: $setup.onShowSizeChange,
        style: {"margin-top":"5px"}
      }, null, 8, ["current", "onChange", "total", "onShowSizeChange"])
    ]),
    _createVNode(_component_x_dialog, {
      title: $setup.isAdd ? '添加广告数据' : '编辑广告数据',
      visible: $setup.dislogVisible,
      onCancel: _cache[20] || (_cache[20] = ($event: any) => {$setup.dislogVisible = false; $setup.addLoading = false;}),
      onConfirm: $setup.confirm,
      loading: $setup.addLoading,
      onIsDestroyOnClose: _cache[21] || (_cache[21] = ($event: any) => ($setup.addLoading = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: $setup.formState,
          ref: "formRef",
          labelCol: { span: 6, offset: 0 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "广告账户ID",
              name: "adsId",
              rules: [{ required: true, message: '请输入广告账户ID!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "请输入广告账户ID",
                  value: $setup.formState.adsId,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (($setup.formState.adsId) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "额度",
              name: "amount",
              rules: [{ required: true, message: '请输入额度!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  placeholder: "请输入额度",
                  value: $setup.formState.amount,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (($setup.formState.amount) = $event)),
                  min: 0,
                  style: {"width":"100%"}
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "FB连接",
              name: "online"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: $setup.formState.online,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => (($setup.formState.online) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode("离线")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("在线")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "母BM",
              name: "bmBase"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "请输入母BM",
                  value: $setup.formState.bmBase,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => (($setup.formState.bmBase) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "BM情况",
              name: "bmLevel"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "请输入BM情况",
                  value: $setup.formState.bmLevel,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => (($setup.formState.bmLevel) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "时区",
              name: "gmt"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: $setup.formState.gmt,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => (($setup.formState.gmt) = $event)),
                  placeholder: "请选择时区",
                  "allow-clear": ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.timeZoneList, (tz) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: tz.value,
                        value: tz.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(tz.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "指纹",
              name: "fingerId",
              rules: [{ required: true, message: '请选择指纹!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: $setup.formState.fingerId,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => (($setup.formState.fingerId) = $event)),
                  placeholder: "请选择指纹",
                  "allow-clear": "",
                  "show-search": "",
                  "filter-option": (input, option) => (option?.value ?? '').toString().toLowerCase().includes(input.toLowerCase())
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.bmLevelOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: item,
                        value: item
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "filter-option"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "售价",
              name: "price"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  value: $setup.formState.price,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => (($setup.formState.price) = $event)),
                  placeholder: "请输入售价",
                  "addon-before": "$",
                  min: 0,
                  precision: 2,
                  style: {"width":"100%"}
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "简介",
              name: "intro"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: $setup.formState.intro,
                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => (($setup.formState.intro) = $event)),
                  placeholder: "请输入简介",
                  rows: 3
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "标签",
              name: "tag"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: $setup.tagArray,
                  "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => (($setup.tagArray) = $event)),
                  mode: "tags",
                  placeholder: "请选择或输入标签，回车添加",
                  "allow-clear": "",
                  style: {"width":"100%"}
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "上架",
              name: "isShow"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: $setup.formState.isShow,
                  "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => (($setup.formState.isShow) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode("否")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("是")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            (!$setup.isAdd)
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 0,
                  label: "状态"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio_group, {
                      name: "status",
                      value: $setup.formState.status,
                      "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => (($setup.formState.status) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio, { value: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode("待出售")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_radio, { value: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode("已出售")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_radio, { value: 2 }, {
                          default: _withCtx(() => [
                            _createTextVNode("被封禁")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!$setup.isAdd && $setup.formState.status === 2)
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 1,
                  label: "封禁原因",
                  name: "stopType",
                  rules: [{ required: $setup.formState.status === 2, message: '请选择封禁原因!' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: $setup.formState.stopType,
                      "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => (($setup.formState.stopType) = $event)),
                      placeholder: "请选择封禁原因"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select_option, { value: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode("未知")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode("客户问题")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: 2 }, {
                          default: _withCtx(() => [
                            _createTextVNode("技术封禁")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["rules"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["title", "visible", "onConfirm", "loading"])
  ], 64))
}